import Component from 'gia/Component'

export default class ComponentPrintList extends Component {
  constructor(element) {
    super(element)
  }

  print() {
    const trigger = document.querySelector('.print svg')

    trigger.addEventListener('click', () => {
      window.print()
    })
  }

  mount() {
    this.print()
  }
}



// WEBPACK FOOTER //
// ./scripts/components/PrintList.js